import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/cases/listpage/featureEngineering/Template'

const FeatureEngineering: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'事例 実績 特徴量エンジニアリング 生成AI UI生成 Bellona'}
        image={'https://www.i3design.jp/ogp_logo.png'}
        url={'https://www.i3design.jp/cases/feature-engineering/'}
        title="特徴量エンジニアリングと生成AI | 事例 | i3DESIGN アイスリーデザイン"
        description="特徴量エンジニアリングと生成AIのケーススタディを紹介します｜クラウドネイティブ、AI駆動開発、デザインシステムに精通した様々な支援実績がございます。UX/UIデザイン、モダンスタック技術、CI/CD、DevOps環境、AIエージェントをフル活用した開発スタイルで顧客のデジタルシフトを支援します。"
      />
      <Template pageId={1} />
    </>
  )
}

export default FeatureEngineering
